import { 
  api_get_profile_list_url,
  api_update_profile_url
} from "./profileApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { parser_get_profile_list, parser_update_profile } from "./profileParser";
import { PAGE } from "../../helpers/constants";

// Thunks
export const get_profile_list = createAsyncThunk(
  "profile/get_profile_list",
  async (payload) => {
    try {
      const response = await api_get_profile_list_url(payload);
      const data = parser_get_profile_list(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const update_profile = createAsyncThunk(
  "profile/update_profile",
  async (formData) => {
    try {
      const { user_id, ...updated_data } = formData;
      const response = await api_update_profile_url(user_id, updated_data);
      const data = parser_update_profile(response);
      return { data };
    } catch (error) {
      console.error("Update profile failed:", error);
      throw new Error(error);
    }
  }
);

// Initial state
const initialState = {
  profile_id: null,  
  user_id: null,     
  profile_list: [],
  selected_data: null,
  common_loading: false,
  is_profile_modal_open: false,
  c_action: null,
  page: PAGE - 1,
  total_profile_count: 0,
  selected_status: '',
  search_query: ''
};

// Slice
export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileId: (state, action) => {
      state.profile_id = action.payload;
    },
    setId: (state, action) => {
      state.user_id = action.payload;
    },
    setSelectedData: (state, action) => {
      state.selected_data = action.payload;
    },
    setProfileModalOpen: (state, action) => {
      state.is_profile_modal_open = action.payload;
    },
    setAction: (state, action) => {
      state.c_action = action.payload;
    },
    setProfilePage: (state, action) => {
      state.page = action.payload;
    },
    setStatus: (state, action) => {
      state.selected_status = action.payload || '';
    },
    setSearchQuery: (state, action) => {
      state.search_query = action.payload;
    }
  },
  extraReducers: (builder) => {
    // get_profile_list
    builder.addCase(get_profile_list.pending, (state) => {
      state.common_loading = true;
    });
    builder.addCase(get_profile_list.fulfilled, (state, action) => {
      state.common_loading = false;
      const profiles = action.payload?.data || [];
      state.profile_list = profiles ? [profiles] : [];
      state.total_profile_count = profiles.length;
    });
    builder.addCase(get_profile_list.rejected, (state) => {
      state.common_loading = false;
    });

    // update_profile
    builder.addCase(update_profile.pending, (state) => {
      state.common_loading = true;
    });
    builder.addCase(update_profile.fulfilled, (state, action) => {
      state.common_loading = false;
      state.profile_list = state.profile_list.map((profile) =>
        profile.id === action.payload.data.id ? { ...profile, ...action.payload.data } : profile
      );
      if (state.selected_data?.id === action.payload.data.id) {
        state.selected_data = { ...state.selected_data, ...action.payload.data };
      }
    });
    builder.addCase(update_profile.rejected, (state) => {
      state.common_loading = false;
    });
  }
});

export const {
  setProfileId,
  setId,
  setSelectedData,
  setProfileModalOpen,
  setAction,
  setProfilePage,
  setStatus,
  setSearchQuery
} = profileSlice.actions;

export default profileSlice.reducer;
